import { GetterTree } from "vuex";
import { IAppState } from "./app.inteface";
import {
  IRootState,
  IStaff,
  IWhoAmI,
  IServiceDoneDefinition,
  IServiceTodoDefinition,
  IPath,
  ISnackbar,
	ICustTypeDto,
	IServiceDTO,
	DialogConfig,
	BlockerConfig
} from "@/interfaces";

type AppGetter = GetterTree<IAppState, IRootState>;

export const getters: AppGetter = {
	tax(state: IAppState): number{
		return state.load? state.load.InvoiceTax : 0;
	},
	materialCharge(state: IAppState): number{
		return state.load? state.load.MaterialCharge : 0;
	},
	serviceItems(state: IAppState): IServiceDTO[]{
		return state.load
		?state.load.ServiceItems
		: [];
	},
	custTypes(state:IAppState): ICustTypeDto[]{
		return state.load
							?state.load.CustTypes
							: [];
	},
  staff(state: IAppState): IStaff[] {
    return state.load
      ? state.load.Staff.map(s => {
          s.Roles = s.Roles.map(r => +r);
          return s;
        })
      : [];
  },
  staffWithMe(state: IAppState): IStaff[] {
    let staff = state.load
      ? state.load.Staff.map(s => {
          s.Roles = s.Roles.map(r => +r);
          return s;
        })
      : [];

    staff.push({
      RecordID: state.load!.WhoAmI.UserID,
      Roles: state.load!.WhoAmI.Roles,
      LName: state.load!.WhoAmI.LName,
      FName: state.load!.WhoAmI.FName,
			Email: "",
			Initials: "",
			IsActive: state.load!.WhoAmI.IsActive,
    });
    return staff;
  },
  isAdmin(state: IAppState): boolean {
    return state.load ? state.load.WhoAmI.Roles.includes(30) : false;
  },
  user(state: IAppState): IWhoAmI | null {
    return state.load ? state.load.WhoAmI : null;
  },
  servicesDone(state: IAppState): IServiceDoneDefinition[] {
    return state.load ? state.load.ServicesDone : [];
  },
  servicesToDo(state: IAppState): IServiceTodoDefinition[] {
    return state.load ? state.load.ServicesToDo : [];
  },
  paths(state: IAppState): IPath[] {
    return state.load ? state.load.Paths : [];
  },
  logged(state: IAppState): boolean {
    return state.logged;
  },
  loading(state: IAppState): boolean {
    return state.loading;
  },
  technician(state: IAppState): IStaff[] {
    return state.load ? state.load.Staff.filter(s => s.Roles.includes(0)) : [];
  },
  salesMan(state: IAppState): IStaff[] {
    return state.load ? state.load.Staff.filter(s => s.Roles.includes(20)) : [];
  },
  shopMan(state: IAppState): IStaff[] {
    return state.load ? state.load.Staff.filter(s => s.Roles.includes(10)) : [];
  },
  getSnackbarData(state: IAppState): ISnackbar | null {
    return state.snackbar;
	},
  getToken(state: IAppState): string {
    return state.token;
  },
  getExpiredTokenDialog(state: IAppState): boolean {
    return state.expiredTokenDialog;
	},
	getDialogData(state: IAppState): DialogConfig{
		return state.dialog;
	},
	getBlockerData(state: IAppState): BlockerConfig{
		return state.blocker;
	},
	
	getTimestampUsers(state: IAppState):string{
		return state.timestampUsers;
	},
	getTimestampInvoices(state: IAppState):string{
		return state.timestampInvoices;
	},
	getTimestampCustomers(state: IAppState):string{
		return state.timestampCustomers;
	},
	getTimestampStaff(state: IAppState):string{
		return state.timestampStaff;
	},
};
